import { ActionTypes } from "../contants/action-types"

export const patientDetails = (details) => {
    return {
        type: ActionTypes.SET_PATIENTDETAILS,
        payload: details
    }
}

export const appointmentType = (details) => {
    return {
        type: ActionTypes.SET_APPOINTMENTTYPE,
        payload: details
    }
}

export const slotSelection = (details) => {
    return {
        type: ActionTypes.SET_SLOTSELECTION,
        payload: details
    }
}

export const insurance = (details) => {
    return {
        type: ActionTypes.SET_INSURANCE,
        payload: details
    }
}